var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15V17C19 18.2632 18.2632 19 17 19H7C5.73684 19 5 18.2632 5 17V7C5 5.73684 5.73684 5 7 5H9C9.54386 5 10 4.54386 10 4C10 3.45614 9.54386 3 9 3H7C4.75439 3 3 4.75439 3 7V17C3 19.2456 4.75439 21 7 21H17C19.2456 21 21 19.2456 21 17V15C21 14.4561 20.5439 14 20 14C19.4561 14 19 14.4561 19 15ZM21 10V4C21 3.45614 20.5439 3 20 3C19.4561 3 19 3.45614 19 4V10C19 10.5439 19.4561 11 20 11C20.5439 11 21 10.5439 21 10ZM10.7018 14.7018L20.7018 4.70175C20.8947 4.52632 21 4.2807 21 4C21 3.45614 20.5439 3 20 3C19.7193 3 19.4737 3.10526 19.2982 3.29825L9.29825 13.2982C9.10526 13.4737 9 13.7193 9 14C9 14.5439 9.45614 15 10 15C10.2807 15 10.5263 14.8947 10.7018 14.7018ZM20 3H14C13.4561 3 13 3.45614 13 4C13 4.54386 13.4561 5 14 5H20C20.5439 5 21 4.54386 21 4C21 3.45614 20.5439 3 20 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open_in_new.5a9a5817.svg";
export { ForwardRef as ReactComponent };